
import { profilesApiRoot as apiRoot } from 'app/config';

export const INITIATE_PAYMENT_REQUEST = 'INITIATE_PAYMENT_REQUEST';
export const INITIATE_PAYMENT_SUCCESS = 'INITIATE_PAYMENT_SUCCESS';
export const INITIATE_PAYMENT_FAILURE = 'INITIATE_PAYMENT_FAILURE';

export const initiatePayment = (paymentData) => {
    return async (dispatch) => {
        dispatch({ type: INITIATE_PAYMENT_REQUEST });
        try {
            const response = await fetch(`${apiRoot}/Stripe/api/checkout`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    price_id: paymentData.price_id,
                    trialPeriod: paymentData.trialPeriod,
                    client_reference_id: paymentData.clientReferenceId
                })
            });

            const result = await response.json();

            if (result.success && result.url) {
                dispatch({ type: INITIATE_PAYMENT_SUCCESS });
                window.location.href = result.url;
            } else {
                throw new Error(result.msg || 'Unknown error');
            }
        } catch (error) {
            dispatch({ type: INITIATE_PAYMENT_FAILURE, error: error.message });
        }
    };
};
